import { __decorate, __extends } from "tslib";
import { CustomElement, attachShadowTemplate, upgradeProperty, FoundationProperty, } from '@tyler-components-web/core';
import { ChipFieldAdapter } from './chip-field-adapter';
import { ChipFieldFoundation } from './chip-field-foundation';
import { CHIP_FIELD_CONSTANTS } from './chip-field-constants';
var template = require('./chip-field.html');
var styles = require('./chip-field.css');
var ChipFieldComponent = /** @class */ (function (_super) {
    __extends(ChipFieldComponent, _super);
    function ChipFieldComponent() {
        var _this = _super.call(this) || this;
        attachShadowTemplate(_this, CHIP_FIELD_CONSTANTS.elementName, template, styles);
        _this._foundation = new ChipFieldFoundation(new ChipFieldAdapter(_this));
        return _this;
    }
    Object.defineProperty(ChipFieldComponent, "observedAttributes", {
        get: function () {
            return [
                CHIP_FIELD_CONSTANTS.attributes.INVALID,
                CHIP_FIELD_CONSTANTS.attributes.REQUIRED,
                CHIP_FIELD_CONSTANTS.attributes.FLOAT_LABEL_TYPE,
            ];
        },
        enumerable: true,
        configurable: true
    });
    ChipFieldComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'invalid');
        upgradeProperty(this, 'required');
        upgradeProperty(this, 'floatLabelType');
    };
    ChipFieldComponent.prototype.connectedCallback = function () {
        var _this = this;
        if (this._requiredElementsPresent()) {
            this._foundation.connect();
        }
        else {
            this._ensureElementsPresent().then(function () {
                _this._foundation.connect();
            });
        }
    };
    ChipFieldComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    ChipFieldComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case CHIP_FIELD_CONSTANTS.attributes.INVALID:
                this.invalid = this.hasAttribute(CHIP_FIELD_CONSTANTS.attributes.INVALID);
                break;
            case CHIP_FIELD_CONSTANTS.attributes.REQUIRED:
                this.required = this.hasAttribute(CHIP_FIELD_CONSTANTS.attributes.REQUIRED);
                break;
            case CHIP_FIELD_CONSTANTS.attributes.FLOAT_LABEL_TYPE:
                this.floatLabelType = newValue;
                break;
        }
    };
    ChipFieldComponent.prototype._ensureElementsPresent = function () {
        var _this = this;
        return new Promise(function (resolve) {
            if (_this._requiredElementsPresent()) {
                resolve();
                return;
            }
            var observer = new MutationObserver(function (changes) {
                var hasAddedNodes = changes.reduce(function (prev, curr) { return prev + curr.addedNodes.length; }, 0) > 0;
                if (hasAddedNodes) {
                    if (_this._requiredElementsPresent()) {
                        observer.disconnect();
                        resolve();
                    }
                }
            });
            observer.observe(_this, { childList: true, subtree: true });
        });
    };
    ChipFieldComponent.prototype._requiredElementsPresent = function () {
        var inputElement = this.querySelector(CHIP_FIELD_CONSTANTS.selectors.INPUT);
        return !!inputElement;
    };
    /**
     * Controls whether the label should be floating or not.
     * @param {boolean} value
     */
    ChipFieldComponent.prototype.floatLabel = function (value) {
        this._foundation.floatLabel(value);
    };
    __decorate([
        FoundationProperty()
    ], ChipFieldComponent.prototype, "invalid", void 0);
    __decorate([
        FoundationProperty()
    ], ChipFieldComponent.prototype, "required", void 0);
    __decorate([
        FoundationProperty()
    ], ChipFieldComponent.prototype, "floatLabelType", void 0);
    ChipFieldComponent = __decorate([
        CustomElement({
            name: CHIP_FIELD_CONSTANTS.elementName,
        })
    ], ChipFieldComponent);
    return ChipFieldComponent;
}(HTMLElement));
export { ChipFieldComponent };
